<template>
  <div class="cwjs" style=" position: relative;width: 95%; margin: 0 auto;">
    <div class="backBtn">
      <el-button type="primary" size="medium" @click="goBack">返回</el-button>
    </div>
    <div class="productInfo">
      <div class="infoL">
        <img :src="goodsDetail.goodsImage" alt />
        <div class="detail">
          <h1>{{goodsDetail.goodsCommonName}}</h1>
          <p>规格：{{goodsDetail.goodsName}}</p>
        </div>
      </div>
      <div class="infoR">
        <div>
          <span>支付金额：￥{{orderInfo.payMoney}}</span>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <!--SVIP权益-->
    <div class="svipSer" v-if="$route.query.orderType == 3">
      <div class="pubTit">
        <div class="pubTitL" style="font-weight:800;">权益信息</div>
        <div class="pubTitR">有效期：{{consume.validDays}}个月 到期时间：{{consume.endTime}}</div>
      </div>
      <div class="service">
        <table
          class="table"
          width="100%"
          border="1"
          cellspacing="0"
          cellpadding="0"
          v-for="service in serviceInfo"
          :key="service.id"
        >
          <tr>
            <th colspan="5">服务权益包名称：{{service.cardbagName}}</th>
          </tr>
          <tr>
            <td>项目名称</td>
            <td width="15%">总次数</td>
            <td width="15%">剩余次数</td>
            <td width="15%">使用次数</td>
          </tr>
          <tr v-for="item in service.itemVOList" :key="item.id">
            <td>{{item.itemName}}</td>
            <td>
              <span v-if="item.total == 999">不限次</span>
              <span v-else>{{item.total}}</span>
            </td>
            <td>
              <span v-if="item.useableNumber == 999">不限次</span>
              <span v-else>{{item.useableNumber}}</span>
            </td>
            <td>{{item.usedNumber}}</td>
          </tr>
        </table>
      </div>
    </div>
    <!--VIP权益-->
    <div class="svipSer" v-else-if="$route.query.orderType == 2">
      <div class="pubTit">
        <div class="pubTitL" style="font-weight:800;">权益信息</div>
        <div class="pubTitR">有效期：{{consume.validDays}}个月 到期时间：{{consume.endTime}}</div>
      </div>
      <table
        class="table"
        width="100%"
        border="1"
        cellspacing="0"
        cellpadding="0"
        style="margin-top: 10px;"
      >
        <tr>
          <td>权益名称</td>
          <td>权益类型</td>
          <td>权益描述</td>
        </tr>
        <tr v-for="item in vipInterestList" :key="item.id">
          <td>{{item.interestName}}</td>
          <td>
            <span v-if="item.interestState == 0">官方</span>
            <span v-else-if="item.interestState == 1">定制</span>
          </td>
          <td>{{item.interestDescribe}}</td>
        </tr>
      </table>
    </div>
    <!--实体-->
    <div class="entity" v-else-if="$route.query.orderType == 1">
      <el-row>
        <el-col :span="12">
          <div class="svipSer" style=" margin-right: 5px; height: 210px;">
            <div class="pubTit">
              <div class="pubTitL">收货信息</div>
            </div>
            <p style=" margin-top: 10px; line-height: 30px;">
              收货人：{{wuliuInfo.name}}
              <br />
              收货人手机号：{{wuliuInfo.mobile}}
              <br />
              收货地址：{{wuliuInfo.address}}
              <br />
            </p>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="svipSer" style=" margin-left: 5px; height: 210px;">
            <div class="pubTit">
              <div class="pubTitL">物流信息</div>
            </div>
            <div class="wuliu">
              <el-form label-width="100px" style="width:50%">
                <el-form-item label="物流公司：">
                  <el-select
                    style="width: 120px"
                    v-model="wuliuForm.companyId"
                    clearable
                    placeholder="请选择区域"
                  >
                    <el-option
                      :label="value"
                      :value="key"
                      :key="key"
                      v-for="(value, key) in wuliuCompany"
                    ></el-option>
                  </el-select>
                  <!--<span style="color: #5a5e66" v-else>{{wuliuForm.company}}</span>-->
                </el-form-item>
                <el-form-item label="物流单号：">
                  <el-input v-model="wuliuForm.order"></el-input>
                  <!--<span style="color: #5a5e66" v-else>{{wuliuForm.order}}</span>-->
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="editWuLiu"
                    v-if="!wuliuForm.company && orderState !== 1"
                  >添加</el-button>
                  <el-button
                    type="primary"
                    @click="editWuLiu"
                    v-if="wuliuForm.company && orderState !== 1"
                  >修改</el-button>
                  <el-button type="info" v-else-if="orderState === 1">添加</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--O2O商品-->
    <div class="o2o" v-else-if="$route.query.orderType == 0">
      <el-row>
        <el-col :span="12">
          <div class="svipSer" style=" margin-right: 5px; height: 210px;">
            <div class="pubTit">
              <div class="pubTitL" style="font-weight:800;">核销信息</div>
              <div class="pubTitR"></div>
            </div>
            <div class="qrcode">
              <!--<img :src="consume.codeImg" alt="">-->
              <p>
                到期时间：{{goodsDetail.validTime}}
                <br />
                核销码：{{consume.code}}
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="svipSer" style=" margin-left: 5px;">
            <div class="pubTit">
              <div class="pubTitL" style="font-weight:800;">订单状态</div>
              <i class="el-icon-bottom"></i>
            </div>
            <div class="orderState">
              <div class="item item_his">
                <div class="itemL">
                  已付款
                  <i class="el-icon-arrow-down f_lv"></i>
                </div>
                <div class="itemR">支付成功时间：{{orderInfo.payTime}}</div>
              </div>
              <div
                class="item"
                :class="{'item_cur' : orderState === 4 && !consume.subscribeTime, 'item_his' : orderState > 4 && consume.subscribeTime}"
              >
                <div class="itemL">
                  预约
                  <i class="el-icon-arrow-down" :class="consume.subscribeTime ? 'f_lv' : ''"></i>
                </div>
                <div class="itemR">预约消费时间：{{consume.subscribeTime || '暂无'}}</div>
              </div>
              <div
                class="item"
                :class="{'item_cur' : orderState === 4 && consume.subscribeTime, 'item_his' : orderState > 4}"
              >
                <div class="itemL">
                  消费
                  <i class="el-icon-arrow-down"></i>
                </div>
                <div class="itemR" v-if="orderState > 4">消费时间：{{consume.consumeTime}}</div>
                <div class="itemR" v-else>未消费</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="svipSer">
            <el-row>
              <el-col :span="12">
                <div class="pubTit">
                  <div class="pubTitL" style="font-weight:800;">服务商家信息</div>
                </div>
                <p class="storeInfo">
                  门店名称：{{storeDetail.storeName}}
                  <br />
                  营业时间：{{storeDetail.workTime}}
                  <br />
                  联系电话：{{storeDetail.storeTel}}
                  <br />
                  地址： {{storeDetail.areaInfo}}
                </p>
              </el-col>
              <el-col :span="12">
                <div id="allmap"></div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="svipSer orderInfo">
      <div class="pubTit">
        <div class="pubTitL" style="font-weight:800;">订单信息</div>
      </div>
      <el-row>
        <el-col :span="8">
          <p>
            <span class="l">订单编号：</span>
            <span class="r">{{orderInfo.orderSn}}</span>
          </p>
          <p>
            <span class="l">订单类型：</span>
            <span class="r" v-if="$route.query.orderType == 0">O2O</span>
            <span class="r" v-else-if="$route.query.orderType == 1">实物</span>
            <span class="r" v-else-if="$route.query.orderType == 2">VIP</span>
            <span class="r" v-else-if="$route.query.orderType == 3">SVIP</span>
            <span class="r" v-else-if="$route.query.orderType == 6">次卡</span>
          </p>
          <p>
            <span class="l">订单来源：</span>
            <span class="r" v-if="orderInfo.orderFrom === 0">APP</span>
            <span class="r" v-else-if="orderInfo.orderFrom === 1">web</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -1">小程序</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -2">管家分享购买的</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -3">微信公众号</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -4">浙商订单</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -5">挪车码</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -6">vip小程序</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -7">vip礼包</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -8">激活码</span>
            <span class="r" v-else-if="orderInfo.orderFrom === -8">激活码</span>
            <span class="r" v-else-if="orderInfo.orderFrom == '-11'">河南石化</span>
            <span v-else-if="orderInfo.orderFrom == '-10'">WEB裂变活动</span>
            <span v-else-if="orderInfo.orderFrom == '-14'">小程序裂变活动</span>
            <span v-else-if="orderInfo.orderFrom == '-13'">核销码</span>
            <span v-else-if="orderInfo.orderFrom == '-15'">VIP新人礼</span>
            <span class="r" v-else>分销商</span>
          </p>
          <p>
            <span class="l">下单会员手机号：</span>
            <span class="r">{{orderInfo.buyerTel}}</span>
          </p>
        </el-col>
        <el-col :span="8">
          <p>
            <span class="l">优惠：</span>
            <span class="r">{{orderInfo.preferential}}</span>
          </p>
          <p>
            <span class="l">支付金额：</span>
            <span class="r">￥{{orderInfo.payMoney}}</span>
          </p>
          <p>
            <span class="l">支付时间：</span>
            <span class="r">{{orderInfo.payTime}}</span>
          </p>
          <p>
            <span class="l">支付方式：</span>
            <span class="r" v-if="orderInfo.paymentCode === 'alipay'">支付宝支付</span>
            <span class="r" v-if="orderInfo.paymentCode === 'webwxpay'">微信web支付</span>
            <span class="r" v-if="orderInfo.paymentCode === 'wxpay'">微信APP支付</span>
            <span class="r" v-if="orderInfo.paymentCode === 'ccbpay'">银联支付</span>
            <span class="r" v-if="orderInfo.paymentCode === 'online'">在线支付</span>
            <span class="r" v-if="orderInfo.paymentCode === 'offline'">线下支付</span>
          </p>
        </el-col>
        <el-col :span="8">
          <p>
            <span class="l">退款金额：</span>
            <span class="r">{{orderInfo.refundMoney}}</span>
          </p>
          <p>
            <span class="l">退款时间：</span>
            <span class="r">{{orderInfo.refundTime}}</span>
          </p>
          <p>
            <span class="l">退款操作人：</span>
            <span class="r">{{orderInfo.refundOperater}}</span>
          </p>
          <p>
            <span class="l">购买数量：</span>
            <span class="r">{{goodsDetail.goodsNum}}</span>
          </p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { baseUrl2, devCode2 } from '@/http/baseUrl';
// import { BaiduMap, BmScale, BmGeolocation } from 'vue-baidu-map';
import loadMap from '@/http/Bmap.js';
export default {
  name: 'orderDetail',
  data () {
    return {
      currentPage: 1,
      bmapKey: 'uoIygmc3eClZXGtfvujiCo7mpI1DAxhf',
      myMap: null,
      postParams: {
        region: '',
        orderType: '',
        orderState: '',
        content: '',
        time: '',
        paymentCode: '',
        source: '',
        sourceChild: '',
        class: '',
        class_2: '',
        class_3: '',
        isReserve: '',
        pageSize: 10,
        pageIndex: 0
      },
      totalResult: 0,
      totalPage: 0,
      tableData: [],
      dialog: false,
      serviceInfo: [
        {
          id: 11,
          title: '免费养护',
          list: [
            {
              name: '标准洗车6次',
              totalCount: 6,
              laveCount: 2,
              useCount: 4,
              id: 1,
              hasUse: false
            },
            {
              name: '标准洗车6次',
              totalCount: 6,
              laveCount: 2,
              useCount: 4,
              id: 2,
              hasUse: true
            }
          ]
        },
        {
          id: 22,
          title: 'SVIP服务权益',
          list: [
            {
              name: '标准洗车6次',
              totalCount: 6,
              laveCount: 2,
              useCount: 4,
              id: 1
            },
            {
              name: '标准洗车6次',
              totalCount: 6,
              laveCount: 2,
              useCount: 4,
              id: 2
            }
          ]
        }
      ],
      vipInterestList: [],
      orderInfo: {
        busi_type: '502',
        buyer_tel: '13837100135',
        coupon: 0,
        discountTicketCode: '',
        goodsServiceItemsList: '',
        logistics_fee: '',
        nominal_value: '',
        order_amount: 0,
        order_id: '',
        order_sn: '2000000013372701',
        order_state: '正常',
        pay_money: 0,
        pay_time: 1558495600000,
        paymentCode: '',
        store_id: 31,
        strpayTime: '',
        visible: false
      },
      storeDetail: {},
      goodsDetail: {},
      consume: {
        code: '',
        codeImg: '',
        validDays: '',
        endTime: '',
        subscribeTime: ''
      },
      orderState: '',
      wuliuInfo: {},
      wuliuForm: {
        company: '',
        order: '',
        companyId: ''
      },
      wuliuCompany: []
    };
  },
  watch: {},
  created () {
    this.getWuliuC();
    this.getOrderDetail();
  },
  mounted () {},
  methods: {
    // 获取订单详情
    getOrderDetail () {
      // this.axios.get(`/orderManage/orderDetail&orderId=${this.$route.query.orderId}`, {
      // params: {
      // }
      this.axios({
        url: `/orderManage/orderDetail${devCode2}&orderId=${this.$route.query.orderId}`,
        method: 'get',
        params: {},
        baseURL: baseUrl2
      })
        .then(response => {
          let res = response.data;
          if (res.ok) {
            this.orderInfo = res.data.orderDetail;
            this.goodsDetail = res.data.goodsDetail;
            this.consume.code = res.data.consumeCode;
            this.consume.codeImg = res.data.codeImg;
            this.consume.validDays = res.data.vaildTime;
            this.consume.endTime = res.data.vaildDate;
            this.consume.subscribeTime = res.data.subscribeTime;
            this.consume.consumeTime = res.data.consumeTime;
            this.orderState = res.data.orderState;
            this.storeDetail = res.data.storeDetail || {};
            this.vipInterestList = res.data.vipInterestList || [];
            this.serviceInfo = res.data.verificationCardBagBOList;
            this.wuliuInfo.address = res.data.address || '';
            this.wuliuInfo.mobile = res.data.mobile || '';
            this.wuliuInfo.name = res.data.name || '';
            this.wuliuForm.company = res.data.logisticName;
            this.wuliuForm.order = res.data.logisticNum;
            for (let key in this.wuliuCompany) {
              if (this.wuliuCompany[key] === this.wuliuForm.company) {
                this.wuliuForm.companyId = key;
              }
            }
            if (this.storeDetail.storeName) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.setMap({
                    lat: this.storeDetail.lat,
                    lng: this.storeDetail.lng,
                    storeName: this.storeDetail.storeName,
                    address: this.storeDetail.areaInfo
                  });
                }, 1000);
              });
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(error => {
          alert(error);
          console.log(error);
        });
    },
    getWuliuC () {
      // 获取订单详情
      this.axios({
        url: `/orderManage/logisticsList` + devCode2,
        method: 'get',
        baseURL: baseUrl2
      })
        .then(response => {
          let res = response.data;
          if (res.ok) {
            this.wuliuCompany = res.data;
            for (let key in this.wuliuCompany) {
              if (this.wuliuCompany[key] === this.wuliuForm.company) {
                this.wuliuForm.companyId = key;
              }
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(error => {
          alert(error);
          console.log(error);
        });
    },
    getBatchSettlement () {
      this.axios({
        url: '/admin/orders' + devCode2,
        method: 'get',
        params: this.postParams,
        baseURL: baseUrl2
      })
        .then(response => {
          let res = response.data;
          if (res.ok) {
            this.tableData = res.data.content;
            this.totalResult = res.data.total;
            this.totalPage = res.data.pageTotal;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(error => {
          alert(error);
          console.log(error);
        });
    },
    getClassList (level, id) {
      this.axios({
        url: '/admin/orders/getGcClasschild' + devCode2,
        method: 'get',
        params: {
          gcId: id
        },
        baseURL: baseUrl2
      })
        .then(response => {
          let res = response.data;
          if (res.ok) {
            if (level === 1) {
              this.classList = res.data.options;
            } else if (level === 2) {
              this.classList2 = res.data.options;
            } else if (level === 3) {
              this.classList3 = res.data.options;
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(error => {
          alert(error);
          console.log(error);
        });
    },
    haddleClassChange (value) {
      this.getClassList(2, value);
    },
    haddleClassChange2 (value) {
      this.getClassList(3, value);
    },
    haddleClassChange3 (value) {},
    sizeChange (val) {
      this.postParams.pageSize = val;
      this.postParams.pageIndex = 0;
      this.getBatchSettlement();
      this.currentPage = 1;
    },
    submitSearch () {
      this.postParams.pageIndex = 0;
      this.getBatchSettlement();
      this.currentPage = 1;
    },
    handleCurrentChange (val) {
      this.postParams.pageIndex = val - 1;
      this.getBatchSettlement();
    },
    setParams (curVal) {
      if (curVal) {
        this.postParams.startTime = curVal[0];
        this.postParams.endTime = curVal[1];
      } else {
        this.postParams.startTime = '';
        this.postParams.endTime = '';
      }
    },
    setData (val) {
      console.log(val);
      if (val) {
        this.addNewBatchForm.ext1 = val[0];
        this.addNewBatchForm.ext2 = val[1];
      } else {
        this.addNewBatchForm.ext2 = '';
        this.addNewBatchForm.ext2 = '';
      }
    },
    goCustomList (item) {},
    clearPostParam () {
      this.postParams = {
        orderState: '',
        paymentCode: '',
        buyerTel: '',
        orderSnParent: '',
        orderSn: '',
        goodsName: '',
        storeName: '',
        storeTitle: '',
        pageSize: 10,
        pageIndex: 0
      };
      this.currentPage = 1;
      this.getBatchSettlement();
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: 1,
          colspan: 7
        };
      } else {
        return {
          rowspan: 0,
          colspan: 0
        };
      }
    },
    setMap (storeInfo) {
      loadMap(this.bmapKey)
        .then(() => {
          // 百度地图API功能
          var map = new BMap.Map('allmap');
          console.log('----验证地图是否加载----', map);
          var point = new BMap.Point(storeInfo.lng, storeInfo.lat);
          console.log('----验证地图是否加载----', point);
          var marker = new BMap.Marker(point); // 创建标注
          map.addOverlay(marker); // 将标注添加到地图中
          map.centerAndZoom(point, 15);
          var opts = {
            width: 200, // 信息窗口宽度
            height: 100, // 信息窗口高度
            title: storeInfo.storeName, // 信息窗口标题
            enableMessage: true, // 设置允许信息窗发送短息
            message: storeInfo.address
          };
          var infoWindow = new BMap.InfoWindow(storeInfo.address, opts); // 创建信息窗口对象
          marker.addEventListener('click', function () {
            map.openInfoWindow(infoWindow, point); // 开启信息窗口
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    editWuLiu () {
      // 添加物流信息
      this.axios({
        url: '/orderManage/addLogistics' + devCode2,
        method: 'post',
        params: {
          orderId: this.$route.query.orderId,
          logisticsId: this.wuliuForm.companyId,
          logisticNum: this.wuliuForm.order,
          type: this.wuliuForm.company ? 2 : 1
        },
        baseURL: baseUrl2
      })
        .then(response => {
          let res = response.data;
          if (res.ok) {
            this.$message('添加成功!');
            this.getOrderDetail();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(error => {
          alert(error);
          console.log(error);
        });
    },
    goBack () {
      this.$router.go(-1);
      // this.$router.back(-1);
    }
  }
};
</script>
<style scoped>
.productInfo {
  display: flex;
  justify-content: space-between;
  border: solid 1px #eee;
  padding: 10px;
}
.productInfo .infoL {
  display: inline-block;
}
.productInfo .infoL img {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}
.productInfo .infoL .detail {
  display: inline-block;
  vertical-align: top;
}
.productInfo .infoL .detail h1 {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.productInfo .infoL .detail p {
  color: #666;
  margin-top: 10px;
}
.productInfo .infoR {
  font-size: 14px;
  display: flex;
  align-items: center;
}
.productInfo .infoR span {
  margin-right: 10px;
}
.productInfo .infoR i {
  font-size: 30px;
}
.svipSer {
  border: solid 1px #eee;
  padding: 0 10px 10px 10px;
  margin-top: 10px;
}
.pubTit {
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.table {
  border-collapse: collapse;
  border: solid 1px #eee;
  margin-bottom: 10px;
}
.table th {
  background: #eee;
  padding: 10px;
  border: solid 1px #eee;
}
.table td {
  text-align: center;
  padding: 10px;
  border: solid 1px #eee;
}
.orderInfo p {
  font-size: 13px;
  line-height: 30px;
}
/* .orderInfo p .l{ width: 40%; display: inline-block; text-align: right; } */
.orderInfo p .l {
  width: 40%;
  text-align: right;
}
.orderInfo p .r {
  display: inline-block;
  text-align: left;
}
.qrcode {
  width: 100%;
  height: 140px;
  display: flex;
  align-items: center;
}
.qrcode img {
  width: 100px;
  height: 100px;
  border: solid 1px #eee;
  padding: 5px;
  box-sizing: content-box;
}
.qrcode p {
  margin-top: 0;
  font-size: 14px;
  color: #333;
  text-align: left;
  display: block;
  line-height: 2em;
}
.orderState .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
}
.orderState .item + .item {
  margin-top: 20px;
}
.orderState .item .itemL {
  width: 8em;
  text-align: center;
  line-height: 40px;
  border: solid 1px #999;
  color: #999;
  position: relative;
}
.orderState .item .itemL i {
  position: absolute;
  bottom: -30px;
  left: 50%;
  font-size: 24px;
  display: block;
  height: 30px;
  width: 30px;
  margin-left: -15px;
  color: #999;
}
.orderState .item .itemR {
  width: calc(100% - 8em - 20px);
}
.orderState .item_cur .itemL {
  background: #27c084;
  color: #fff;
  border: solid 1px #27c084;
}
.orderState .item_his .itemL {
  background: #fff;
  color: #27c084;
  border: solid 1px #27c084;
}
.orderState .item:last-child .itemL i {
  display: none;
}
.orderState .item .itemL i.f_lv {
  color: #27c084;
}
.storeInfo {
  margin-top: 10px;
  line-height: 30px;
  font-size: 14px;
}
#allmap {
  width: 100%;
  height: 300px;
  margin: 10px 10px 10px 0;
}

.backBtn {
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  /*position: absolute;*/
  right: 0;
  top: -43px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderQuery/orderDetail.vue